import React from "react";
import styled from "styled-components";
import { breakpoint } from "@utilities";

interface IProps {
    onClick: () => void;
    active: boolean;
    loading?: boolean;
}

export const HeartCommon: React.FC<IProps> = ({ onClick, active, loading = false }) => {
    return (
        <Wrapper
            active={active}
            onClick={loading ? undefined : onClick}
            aria-busy={loading}
            data-loading={loading}
        >
            {loading ? (
                <div className="spinner" />
            ) : (
                <img
                    src={active ? "/images/FilledFavourite.svg" : "/images/Favourite.svg"}
                    alt={active ? "Filled Favourite" : "Favourite"}
                    className="heart-img"
                />
            )}
        </Wrapper>
    );
};

const Wrapper = styled.button<{ active: boolean }>`
    position: relative;
    cursor: pointer;
    background: transparent;
    border: none;
    padding: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;

    &:disabled,
    &[data-loading="true"] {
        cursor: default;
        opacity: 0.6;
    }

    .heart-img,
    .spinner {
        width: 20px;
        height: 20px;

        ${breakpoint.breakMobileMedium`
            width: 28px;
            height: 28px;
        `}
        ${breakpoint.breakIpadPro`
            width: 30px;
            height: 30px;
        `}
    }

    .spinner {
        border: 2px solid rgba(0, 0, 0, 0.1);
        border-top: 2px solid currentColor;
        border-radius: 50%;
        animation: spin 0.8s linear infinite;
    }

    @keyframes spin {
        to {
            transform: rotate(360deg);
        }
    }
`;
